var map = {
	"./Account.json": "b873",
	"./Auth.json": "15dc",
	"./Booking.json": "616b",
	"./Boss.json": "c15a",
	"./Localize.json": "decc",
	"./Manage.json": "038c",
	"./Review.json": "0292",
	"./Settings.json": "d10d",
	"./SideBar.json": "c4ab",
	"./Users copy.json": "a494",
	"./Users.json": "49d6",
	"./meta.json": "7a94"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6c8";